$(document).ready(function () {
  /* ================ Header JS Start ================ */
  function headerspace() {
    var headerHeight =
      $(".announcements-bar").outerHeight() + $(".main-header").outerHeight();
      $("body").css("--HeaderHeight", `${headerHeight}px`);
  }
  headerspace();
  $(window).on("resize load", headerspace);
  $("body").on("click", ".menu-mobile-icon", function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(".header-menu, .menu-wrapper").removeClass("open");
      $("body").removeClass("overflow-hidden");
    } else {
      $(this).addClass("open");
      $(".header-menu, .menu-wrapper").addClass("open");
      $("body").addClass("overflow-hidden");
    }
  });
  $("body").on("click", ".dropdown-menu .icon", function () {
    if ($(window).width() <= 991) {
      let __parents = $(this).parents(".dropdown-menu");
      if (__parents.hasClass("open")) {
        __parents.removeClass("open");
        __parents.find(".dropdown-menu").slideUp(300);
      } else {
        __parents.addClass("open");
        __parents.find(".dropdown-menu").slideDown(300);
      }
    }
  });
  /* ================ Header JS End ================ */
  
  /* ================ Wrapper JS Start ================ */
  $("body").on("click", ".menu-wrapper", function () {
    $(
      ".menu-mobile-icon, .header-menu, .menu-wrapper, .customer-video-popup"
    ).removeClass("open");
    $("body").removeClass("overflow-hidden");
    $(".video-popup-main video").get(0).pause();
  });
  /* ================ Wrapper JS End ================ */
  
  /* ================ FAQ Tab JS Start ================ */
  $("body").on("click", ".faq-tab-header:not(.not-tab) .btn", function (e) {
    e.preventDefault();
    var activeTab = $(this).attr("rel");
    if (!$(this).hasClass("active")) {
      $(".faq-tab-info").hide();
      $(`#${activeTab}`).fadeIn();
      $(".faq-tab-header:not(.not-tab) .btn").removeClass("active");
      $(this).addClass("active");
    }
  });
  $("body").on("click", ".faq-acc-header", function (f) {
    f.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".faq-acc-body").slideUp(200);
    } else {
      $(".faq-acc-header").removeClass("active");
      $(this).addClass("active");
      $(".faq-acc-body").slideUp(200);
      $(this).siblings(".faq-acc-body").slideDown(200);
    }
  });
  /* ================ FAQ Tab JS End ================ */
  
  // ============== Product slider JS Start ============= //
  var productThumbnail = new Swiper(".product-thumbnail", {
    slidesPerView: 4,
    direction: "horizontal",
    spaceBetween: 10,
    breakpoints: {
      601: {
        direction: "horizontal",
        spaceBetween: 10,
        slidesPerView: 5,
      },
      768: {
        direction: "horizontal",
        spaceBetween: 10,
        slidesPerView: 4,
      },
      992: {
        direction: "vertical",
        spaceBetween: 10,
        slidesPerView: 5,
      },
    },
  });
  var productDetailsSlider = new Swiper(".product-details-slider", {
    loop: true,
    spaceBetween: 12,
    thumbs: {
      swiper: productThumbnail,
    },
  });
  // ============== Product slider JS End ============= //
  
  // ============== Cart JS Start ============= //
  $("body").on("click", "[data-cart-open]", function (f) {
    f.preventDefault();
    $(".main-cart-drawer").addClass("open");
    $("body").addClass("overflow-hidden");
  });
  $("body").on("click", ".cart-close-btn", function (f) {
    f.preventDefault();
    $(".main-cart-drawer").removeClass("open");
    $("body").removeClass("overflow-hidden");
  });
  // ============== Cart JS End ============= //

  // ============== Product Recommendations start ============= //
  function productRecommendations(element, initSlider = false) {
    if ($(element).length > 0) {
      var productRecommendationsSection = $(element);
      var url = productRecommendationsSection.data("url");
      $.ajax({
        url: url,
        dataType: "html",
        success: function (data) {
          var htmlData = $(data);
          var recommendations = htmlData.find(element);
          if (recommendations.length && recommendations.html().trim().length) {
            productRecommendationsSection.html(recommendations.html());
            if (initSlider) window.relatedProducts();
          }
        },
        error: function (error) {
          console.log("error", error);
        },
      });
    }
  }

  if ($("body").hasClass("template-product")) {
    productRecommendations(".product-recommendations", true);
  }
  // ============== Product Recommendations end ============= //
  
  // ============== Product add, remove, update start ============= //
  function changeCartData(section_id, element, open_cart_drawer = false) {
    $.get(
      "/cart?section_id=" + section_id + "&t=" + Math.random(),
      function (data) {
        $("[data-cart-item]").html($(data).find("[data-cart-item]").html());
        console.log("Cart Updated");
        productRecommendations(element);
      }
    );
  }

  function activeCartCount() {
    jQuery.getJSON("/cart.js?t=" + Math.random(), function (cart) {
      if (cart.item_count == 0) {
        $("[data-cart-item]").addClass("cart--empty-true");
        $("[data-cart-open]").removeClass("cart-has-item");
      } else {
        $("[data-cart-item]").removeClass("cart--empty-true");
        $("[data-cart-open]").addClass("cart-has-item");
      }
    });
  }

  function updateCart(_this, $parent, itemData, section_id) {
    $(".error-message").remove();
    $.ajax({
      type: "POST",
      url: window.routes.cart_change_url,
      dataType: "json",
      data: itemData,
      success: function (data) {
        changeCartData(section_id, ".cart-recommendations", false);
        activeCartCount();

        setTimeout(function () {
          $parent.find("button, select").removeAttr("disabled");
        }, 2000);
      },
      error: function (response) {
         $parent.find(".cart-list-qty")
          .append(
            '<p class="error-message">' + response.responseJSON.errors + "</p>"
          );

        setTimeout(function () {
          $(".error").remove();
          $parent.find("button, select").removeAttr("disabled");
        }, 5000);
      },
    });
  }

  function addToCart(_this, formData, _this_text, section_id){
     $.ajax({
      type: "POST",
      url: "/cart/add",
      data: formData,
      dataType: "json",
      error: function (xhr, ajaxOptions, thrownError) {
        alert(xhr.status);
      },
    }).done(function (data) {
      _this.find("span:not(.icon)").html("Added");
      changeCartData(section_id, ".cart-recommendations", true);
      activeCartCount();
      setTimeout(function () {
        _this.removeAttr("disabled").find("span:not(.icon)").html(_this_text);
        $(".main-cart-drawer").addClass("open");
        $("body").addClass("overflow-hidden");
      }, 500);
    });
  }
  
  $("body").on("click", "[data-add-to-cart], [data-add-subscribe-to-cart]", function (e) {
    e.preventDefault();
    var _this = $(this),
      _this_text = _this.find("span:not(.icon)").html(),
      form = $(this).closest("form"),
      formData = form.serializeArray(),
      isSubscribeBtn = _this.attr('data-add-subscribe-to-cart'),
      section_id = _this.data("section-id");
    
    _this
      .attr("disabled", "disabled")
      .find("span:not(.icon)")
      .html("Adding...");

    // ADD SELECTED SELLING PLAN
    if (form.data('form') == 'product-page') {
      if (_this.parents().find('[data-product-quantity]').length > 0){
        formData.push({ name: "quantity", value: parseInt(_this.parents().find('[data-product-quantity] [name="quantity"]:checked').val()) });
      }
  
      if (_this.parents().find('[data-radio-type="selling_plan"]').length > 0 && _this.parents().find('[data-radio-type="selling_plan"]').is(':checked')){
        formData.push({ name: "selling_plan", value: _this.parents().find('[name="product-selling_plan"]').val() });
      }
    } else {
      if (typeof isSubscribeBtn !== 'undefined' && isSubscribeBtn !== false){
        formData.push({ name: "selling_plan", value: _this.data('selling_plan_id') });
      }
    }
    // ADD SELECTED SELLING PLAN
    
    addToCart(_this, formData, _this_text, section_id);
  });

  $("body").on("click", ".quantity_btn", function (e) {
    $(".error-message").remove();
    var _this = $(this),
      $parent = $(this).parents('[data-item-list]'),
      error = "",
      input = $(this).parent().find("input"),
      min = input.data("min"),
      max = input.attr("max"),
      step = input.attr("step"),
      section_id = input.data("section-id"),
      input_val = parseInt(input.val());

    $parent.find("button, select").attr("disabled", "disabled");

    error =
      input_val < min
        ? `This item has a minimum of ${min}`
        : input_val > parseInt(max)
        ? `This item has a maximum of ${max}`
        : input_val % parseInt(step) !== 0
        ? `You can only add this item in increments of ${step}`
        : "";

    input_val +=
      $(this).attr("name") == "plus"
        ? parseInt(min) > parseInt(step)
          ? 1
          : 1
        : -1;

    $(this)
      .parents("[data-item-list]")
      .find(".cart-list-qty")
      .append('<p class="error">' + error + "</p>");

    input.val(input_val);
    var key = $parent.find('[name="updates[]"]').data("id"), 
        itemData = "quantity=" + input_val + "&line=" + parseInt(key);
    updateCart($(this), $parent, itemData, section_id);
  });

  $("body").on("click", "[data-cart-delete]", function (e) {
    e.preventDefault();

    var $parent = $(this).parents('[data-item-list]'),
        key = $parent.find('[name="updates[]"]').data("id"), 
        section_id = $parent.find('[name="updates[]"]').data("section-id"),
        itemData = "quantity=0&line=" + parseInt(key);
    
    $parent.find("button, select").attr("disabled", "disabled");
    updateCart($(this), $parent, itemData, section_id);
  });

  $("body").on('change', '[name="update_selling_plan"]', function(e){
    e.preventDefault();
    $(".error-message").remove();
    
    var $parent = $(this).parents('[data-item-list]'), 
        key = $parent.find('[name="updates[]"]').data("id"), 
        qty = $parent.find('[name="updates[]"]').val(),
        section_id = $parent.find('[name="updates[]"]').data("section-id"),
        itemData = "quantity=" + parseInt(qty) + "&line=" + parseInt(key) + '&selling_plan=' + $(this).val();
    
    $(this).parent().find("button, select").attr("disabled", "disabled");
    updateCart($(this), $parent, itemData, section_id);
  });

  $("body").on('click', '.upgrade_selling_plan', function(e){
    e.preventDefault();
    $(".error-message").remove();
    
    var $parent = $(this).parents('[data-item-list]'), 
        key = $parent.find('[name="updates[]"]').data("id"), 
        qty = $parent.find('[name="updates[]"]').val(),
        section_id = $parent.find('[name="updates[]"]').data("section-id"),
        itemData = "quantity=" + parseInt(qty) + "&line=" + parseInt(key) + '&selling_plan=' + $(this).data('subscription-id');
    
    $(this).parent().find("button, select").attr("disabled", "disabled");
    updateCart($(this), $parent, itemData, section_id);
  });
  // ============== Product add, remove, update end ============= //
  
  // ============== Wishlist add event start ============= //
  function checkForSwatWishlist(){
    if (typeof _swat != 'undefined'){
      let event = "sw:addedtocart";
    
      // Define the event listener function
      let listener = function (e) {
        var data = e.detail.d.productData;
        console.log("YAY! Added the product to cart", data);
        var section_id = $('body').hasClass('template-cart') ? 'main-cart' : 'cart-drawer';
        changeCartData(section_id, ".cart-recommendations", true);     
        activeCartCount();
      };
    
      // Add listener for the 'addedtocart' event to the Swym Event Layer
      _swat.evtLayer.addEventListener(event, listener);
    } else {
      setTimeout(checkForSwatWishlist, 500);    
    }
  }
  checkForSwatWishlist();
  // ============== Wishlist add event end ============= //
  
  // ============== Collection subscription toggle start ============= //
  function toggleProductGridVisibility(productGridItems) {
    productGridItems.each(function(i) {
      const productGrid = $(this);
      if (productGrid.find('[data-add-subscribe-to-cart]').length > 0) {
        productGrid.find('[data-add-subscribe-to-cart], [data-normal-price]')
          .toggleClass('hidden');
        productGrid.find('[data-add-to-cart], [data-subscribe-price]')
          .toggleClass('hidden');
      }
    });
  }
  
  $('body').on("change", "[data-subscription-btn]", function (e) {
    const subscriptionButton = $(this),
          productGridSection = subscriptionButton.parents('.product-grid-section'),
          productGridItems = productGridSection.find('.product-grid .product-items');
  
    const toggleTextElement = subscriptionButton.parents(".subscribe-check")
      .find("[data-subscription-toggle]"),
        offText = toggleTextElement.data("subscription-off"),
        onText = toggleTextElement.data("subscription-on");
  
    toggleTextElement.html(subscriptionButton.is(":checked") ? onText : offText);
    toggleProductGridVisibility(productGridItems);
  });
    
  // ============== Collection subscription toggle end ============= //

  // ============== Product subscription toggle start ============= //
  function changePrice(price, compare_at_price, qty, selector, showDiscount) {
    const formattedPrice = Shopify.formatMoney(price * qty, window.shop_money_format);
    selector.html(formattedPrice + (compare_at_price > price ? `<cp>${Shopify.formatMoney(compare_at_price * qty, window.shop_money_format)}</cp>` : "")); 

    if ($('[data-savings-percentage]').length > 0 && showDiscount) {
      const text = $('[data-savings-percentage]').data('text'),
            percentage_off = Math.round(((compare_at_price - price) * 100) / compare_at_price),
            new_text = text.replace('{{ percantage }}', percentage_off) + '%';

      $('[data-savings-percentage]').html(new_text);
    }
  }
  
  function showSavings(price, compare_at_price, selector) {
    const $parent = selector.parents('[data-product-info]'), 
          $qtyInputs = $parent.find('[data-product-quantity] [name="quantity"]');
  
    if ($qtyInputs.length) {
      $qtyInputs.each(function() {
        const $saveLabel = $(this).parents('li').find('.save-label'), 
              qty = parseInt($(this).val()), savings = (compare_at_price - price) * qty;
        if (compare_at_price > price) {
          $saveLabel
            .html(window.products.savings.replace('{{ price }}', Shopify.formatMoney(savings, window.shop_money_format)))
            .attr('data-savings', savings)
            .removeClass('hidden');
        } else {
          $saveLabel.addClass('hidden');
        }
      });
    }
  }
  
  $('body').on('change', '[data-product-subscription] .subscribe-check-input', function(e) {
    e.preventDefault();
    $(this).parents('[data-product-subscription]').find('[data-sub-plan]').removeClass('subscribe');
    $(this).parent('[data-sub-plan]').addClass('subscribe');
  
    const qty = parseInt($(this).parents('[data-product-info]').find('[data-product-quantity] [name="quantity"]:checked').val() || 1),
          $planInput = $(this).parents('[data-sub-plan]').find('[data-radio-type="one_time_purchase"], :selected'), 
          price = $planInput.data('variant-price'), 
          compare_at_price = $planInput.data('variant-compare-at-price'), 
          $priceSelector = $(this).parents('[data-sub-plan]').find('[data-plan-price]');
  
    showSavings(price, compare_at_price, $(this), false);
    changePrice(price, compare_at_price, 1, $priceSelector);
  });
  
  $('body').on('change', '[name="product-selling_plan"]', function(e) {
    e.preventDefault();
    $(this).parents('[data-sub-plan]').find('.subscribe-check-input').trigger('click');
    
    const $parent = $(this).parents('[data-product-info]'), 
          qty = parseInt($parent.find('[data-product-quantity] [name="quantity"]:checked').val() || 1), 
          plan_interval = $(this).find(':selected').data('selling-plan-name'), 
          price = $(this).find(':selected').data('variant-price'), 
          compare_at_price = $(this).find(':selected').data('variant-compare-at-price'), 
          $priceSelector = $(this).parents('[data-sub-plan]').find('[data-plan-price]');
  
    $(this).parents('[data-sub-plan]').find('[data-plan-name]').html(plan_interval);
    
    changePrice(price, compare_at_price, qty, $priceSelector, true);
    showSavings(price, compare_at_price, $(this));
    
  });
  
  $('body').on('change', '[data-product-quantity] [name="quantity"]', function(e) {
    const $parent = $(this).parents('[data-product-info]'), qty = $(this).attr('name') == 'quantity' ? parseInt($(this).val()) : 1;
  
    $parent.find('[data-sub-plan]').each(function() {
      const $planInput = $(this).find('[data-radio-type="one_time_purchase"], :selected'),
            price = $planInput.data('variant-price'), 
            compare_at_price = $planInput.data('variant-compare-at-price'), 
            $priceSelector = $(this).find('[data-plan-price]');
  
      changePrice(price, compare_at_price, qty, $priceSelector);
    });
  });

  // Variant change start
  function renderProductInfo(currentVariant, sectionId, dataProductURL) {
    fetch(dataProductURL+'?variant='+ currentVariant +'&section_id='+ sectionId)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html'), 
              subscription = '#pdp-subscription-'+sectionId,
              price = '#price-'+sectionId,
              addtocartbtn = '[name="add"]';

        if ($(price).length > 0) $(price).html($(html).find('#price-'+sectionId).html());
        if ($(addtocartbtn).length > 0) $(addtocartbtn).html($(html).find('[name="add"]').html());
        if (typeof isdisabled !== 'undefined' && isdisabled !== false ? $(addtocartbtn).attr('disabled','disabled') : $(addtocartbtn).removeAttr('disabled'));
        if ($(subscription).length > 0) $(subscription).html($(html).find('#pdp-subscription-'+sectionId).html());
        
        if ($('body').hasClass('template-product') && $('[data-radio-type="selling_plan"]').length > 0){
          $('[data-radio-type="selling_plan"]').trigger('click');
        }
    });
  }  
  
  $('body').on('change', '[data-product-variants] [name="var-id"]', function(e) {
    e.preventDefault();
    var current_variant = $(this).val(),
        dataSection = $(this).data('section'),
        productForms = $('#product-form-'+dataSection),
        dataProductURL = $(this).data('url');

    productForms.find('[name="id"]').val(current_variant);
    productForms.find('[name="id"]')[0].dispatchEvent(new Event('change', { bubbles: true }));
    
    window.history.replaceState({}, '', dataProductURL+'?variant='+current_variant);
    renderProductInfo(current_variant, dataSection, dataProductURL);
  });
  // Variant change end
  
  // check for pack images or show featured image
  if ($("[data-pack-image]").length > 0) {
    $("[data-pack-image]").each(function () {
      const $this = $(this);
      const imgURL = $this.attr("src");
      const $new_img_url = $this.data("featured-image");
      let timeoutId;
  
      timeoutId = setTimeout(function() {
        console.error("Error loading swatch image:", imgURL);
        $this.attr('src', $new_img_url);
      }, 2000); // Adjust timeout duration as needed
  
      $this.on('load', () => {
        clearTimeout(timeoutId); 
      });
      $this.on('error', () => {
        clearTimeout(timeoutId); 
        console.error("Error loading swatch image:", imgURL);
        $this.attr('src', $new_img_url);
      });
    });
  }

  if ($('body').hasClass('template-product') && $('[data-radio-type="selling_plan"]').length > 0){
    $('[data-radio-type="selling_plan"]').trigger('click');
  }
  // ============== Product subscription toggle end ============= //
});
